import { render, staticRenderFns } from "./user_question_details.vue?vue&type=template&id=72953b3f&scoped=true"
import script from "./user_question_details.vue?vue&type=script&lang=js"
export * from "./user_question_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72953b3f",
  null
  
)

export default component.exports